export const formInputContainerStyles = {
  display: 'flex',
  gap: 2,
  flexDirection: { xs: 'column', sm: 'row' },
  '& > *': {
    flex: { xs: '1 1 100%', sm: '1 1 0' },
    minWidth: { xs: 'unset', sm: '200px' },
    maxWidth: { xs: '100%', sm: '400px' },
  },
} as const;

export const formInputStyles = {
  '& .MuiInputBase-root': {
    height: '40px',
  },
} as const;

export const dateInputContainerStyles = {
  display: 'flex',
  gap: 2,
  flexDirection: 'row',
  flexWrap: 'wrap',
  '& > *': {
    width: '100%',
    '@media (min-width: 510px)': {
      // Desktop: fixed width for date inputs
      width: '190px',
    },
    '@media (min-width: 395px) and (max-width: 509px)': {
      // Tablet: two columns with gap
      width: 'calc(50% - 8px)',
    },
  },
} as const;

export const twoColumnLayoutStyles = {
  display: 'grid',
  gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
  gap: 2,
  marginBottom: 2,
} as const;

export const rentalCostFieldStyles = {
  width: '100%',
  maxWidth: { xs: '100%', sm: '400px' },
  [`@media (max-width: 960px)`]: {
    maxWidth: '100%',
  },
} as const;

export const formFieldsAboveRentalCostStyles = {
  maxWidth: { xs: '100%', sm: '192px' },
  width: '100%',
} as const;
